<template>
    <div class="software-page">
        <!-- 头部深色区域：还原参考图的质感 -->
        <section class="hero-section"
            style="background: url('https://qiniu-au.wifigsmalarm.com/images/panel1.png'); background-size:cover;height: 800px;">
            <div class="hero-content" v-scroll-reveal>
                <h1>酷壹中控屏</h1>
                <p>以极简的视觉设计，呈现丰富而实用的全屋智能控制体验</p>
            </div>
        </section>
        <section class="hero-section"
            style="background: url('https://qiniu-au.wifigsmalarm.com/images/panel2.png'); background-size:cover;height: 800px;">
            <div class="hero-content" v-scroll-reveal>
                <h1>不仅是控制面板</h1>
                <p>它是一个支持本地控制子设备的Zigbee网关，即使网络不稳定也无需担心智能设备无法控制。</p>
            </div>
        </section>
        <section class="hero-section"
            style="background: url('https://qiniu-au.wifigsmalarm.com/images/panel3.png'); background-size:cover;height: 800px;">
            <div class="hero-content" v-scroll-reveal>
                <h1>背景音乐</h1>
                <p>部分机型支持外接喇叭，可以在屏幕上播放喜欢的音乐。</p>
            </div>
        </section>

    </div>
</template>

<script setup>
// import { ref } from 'vue'

// 模拟数据：使用不同颜色代码作为图片占位，包含图上的标题和描述
// const featureCards = ref([
//     { title: '智能设备编排', desc: '支持1x2, 2x2等多种尺寸模块自由组合。', bgColor: '#3b82f6' }, // 蓝色
//     { title: '无缝场景切换', desc: '一键切换观影、阅读、睡眠等多种居家场景。', bgColor: '#10b981' }, // 绿色
//     { title: '环境温控中枢', desc: '实时显示并调节全屋温湿度。', bgColor: '#f59e0b' }, // 橙色
//     { title: '安防实时监控', desc: '时刻掌握家中安全动态，异常自动推送。', bgColor: '#ef4444' }, // 红色
//     { title: '能源数据看板', desc: '可视化用电数据，轻松实现绿色节能。', bgColor: '#8b5cf6' }, // 紫色
//     { title: '个性化日历时钟', desc: '日程安排、天气预报一目了然。', bgColor: '#14b8a6' }  // 蓝绿色
// ])

// 简单的滚动动画指令 (如果你全局已有，可以删除这里的定义)
const vScrollReveal = {
    mounted: (el, binding) => {
        const isZoom = binding.modifiers.zoom
        el.classList.add(isZoom ? 'reveal-zoom' : 'reveal-up')
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    el.classList.add('active')
                    observer.unobserve(el)
                }
            })
        }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' })
        observer.observe(el)
    }
}
</script>

<style scoped>
/* =========================================
   全局与基础样式
   ========================================= */
.software-page {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    width: 100%;
    overflow-x: hidden;
}

.pc-only {
    display: block;
}

.bg-white {
    background-color: #ffffff;
}

/* =========================================
   深色头部区域 (Hero Section)
   ========================================= */
.hero-section {
    background-color: #111111;
    /* 黑色背景 */
    color: #ffffff;
    padding: 120px 20px 80px 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 40vh;
    margin-bottom: 50px;
}

.hero-content {
    max-width: 800px;
    /* ✨ 新增：将文字整体上移100px */
}

.hero-content h1 {
    font-size: 3.5rem;
    font-weight: bold;
    margin-bottom: 24px;
    letter-spacing: 1px;
    transform: translateY(-250px);
}

.hero-content p {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.8;
    transform: translateY(-250px);
}

/* =========================================
   白色内容区域 & 网格排布
   ========================================= */
.features-section {
    padding: 80px 20px 100px 20px;
}

.section-header {
    text-align: center;
    max-width: 900px;
    margin: 0 auto 60px auto;
}

.section-header h2 {
    font-size: 2.2rem;
    color: #1a1a1a;
    font-weight: bold;
    margin-bottom: 20px;
}

.section-header p {
    font-size: 1.05rem;
    color: #666;
    line-height: 1.7;
}

/* ✨ 核心网格布局：自适应排布，支持多张图 */
.image-grid {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    /* PC端默认每列最小 350px，自动填满剩余空间，通常是一行三列或两列 */
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
}

/* 占位卡片样式 */
.image-card {
    position: relative;
    height: 400px;
    /* 固定图片高度 */
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;

    /* 当你有真实图片时，可以在这里添加 background-size: cover; background-position: center; */
}

.image-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* 图上的文字遮罩 (放在底部) */
.card-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 40px 30px 30px 30px;
    /* 黑色渐变背景，确保在任何色块/图片上文字都清晰可见 */
    background: linear-gradient(to top, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0) 100%);
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.card-overlay h3 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.card-overlay p {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.5;
    margin: 0;
}

/* =========================================
   简单的进场动画
   ========================================= */
.reveal-up {
    opacity: 0;
    transform: translateY(40px);
    transition: all 0.8s ease-out;
}

.reveal-zoom {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
    transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.active {
    opacity: 1 !important;
    transform: translate(0, 0) scale(1) !important;
}

/* =========================================
   移动端适配 (Mobile Responsive)
   ========================================= */
@media screen and (max-width: 768px) {
    .pc-only {
        display: none;
    }


    .hero-section {
        padding: 100px 20px 60px 20px;
        min-height: auto;
    }

    .hero-content h1 {
        font-size: 2.5rem;
    }

    .hero-content p {
        font-size: 1rem;
    }

    .features-section {
        padding: 60px 20px;
    }

    .section-header h2 {
        font-size: 1.8rem;
    }

    .image-grid {
        /* 移动端强制变成一列 */
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .image-card {
        height: 300px;
        /* 移动端适当降低卡片高度 */
    }

    .card-overlay {
        padding: 30px 20px 20px 20px;
    }

    .card-overlay h3 {
        font-size: 1.3rem;
    }
}
</style>